import { render } from "./ADataTable.vue?vue&type=template&id=636b66af"
import script from "./ADataTable.vue?vue&type=script&lang=js"
export * from "./ADataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__